import { render, staticRenderFns } from "./storeMarginManage.vue?vue&type=template&id=537595c6&scoped=true&"
import script from "./storeMarginManage.vue?vue&type=script&lang=js&"
export * from "./storeMarginManage.vue?vue&type=script&lang=js&"
import style0 from "./storeMarginManage.vue?vue&type=style&index=0&id=537595c6&prod&lang=less&scoped=true&"
import style1 from "./storeMarginManage.vue?vue&type=style&index=1&id=537595c6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537595c6",
  null
  
)

export default component.exports